import { combineReducers } from 'redux-immutablejs';
import globalReducer from './global';
import ownerReducer from './owner';
import agentReducer from './agent';
import agentBetaReducer from './agentBeta';
import builderplanReducer from './builderplan';
import economicunitsReducer from './economicunits';
import deedReducer from './deed';
import mobileHomeReducer from './mobilehome';
import saleReducer from './sale';
import exemptionReducer from './exemption';
import buildingpermitReducer from './buildingpermit';
import mortgagelender from './mortgagelender';
import widget from './widget';
import webpage from './webpage';
import subcomponent from './subcomponent';
import menuprofile from './menuprofile';
import property from './property';
import codefile from './codefile';
import ciwindow from './ciwindow';
import revisionHistory from './revisionHistory';
import dashboard from './dashboard';
import importReducer from './import';
import electronicRequestReducer from './electronicRequest';

/**
 * The application's main reducer
 */
export default combineReducers({
  global: globalReducer,
  owner: ownerReducer,
  agent: agentReducer,
  agentBeta: agentBetaReducer,
  builderplan: builderplanReducer,
  economicunit: economicunitsReducer,
  deed: deedReducer,
  sale: saleReducer,
  exemption: exemptionReducer,
  buildingpermit: buildingpermitReducer,
  mobileHome: mobileHomeReducer,
  mortgagelender,
  widget,
  webpage,
  subcomponent,
  menuprofile,
  property,
  codefile,
  ciwindow,
  revisionHistory,
  dashboard,
  import: importReducer,
  electronicRequest: electronicRequestReducer,
});
